module.exports = __webpack_public_path__ + "static/media/logo-share.219df7a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-share.png
// module id = 278
// module chunks = 0